const rankings = [
  { rank: 1, title: '长风渡', meta: '古装 · 爱情', hot: '960万热度', desc: '白敬亭宋轶先婚后爱，口碑与热度齐飞', change: 'up' },
  { rank: 2, title: '狂飙', meta: '剧情 · 犯罪', hot: '880万热度', desc: '张译张颂文对手戏封神，年度现象级巨制', change: 'same' },
  { rank: 3, title: '星落凝成糖', meta: '仙侠 · 奇幻', hot: '750万热度', desc: '陈星旭李兰迪演绎绝美仙侠虐恋', change: 'up' },
  { rank: 4, title: '新闻女王', meta: '都市 · 职场', hot: '620万热度', desc: '佘诗曼回归TVB力作，宫斗式新闻大战', change: 'down' },
  { rank: 5, title: '向往的生活7', meta: '真人秀 · 慢综', hot: '510万热度', desc: '何炅黄磊温情收官，治愈系慢生活', change: 'up' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            热门榜单
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            实时热度排行，大家都在追的好剧都在这里
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {rankings.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 md:gap-5 bg-background-100 rounded-xl p-4 md:p-5 border border-background-200/60 hover:border-primary-200/60 transition-colors cursor-pointer"
            >
              <div className={`flex-shrink-0 w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-xl font-heading font-bold text-lg ${
                item.rank === 1
                  ? 'bg-primary-500 text-background-50'
                  : item.rank === 2
                  ? 'bg-accent-500 text-background-50'
                  : item.rank === 3
                  ? 'bg-primary-300 text-primary-950'
                  : 'bg-secondary-200 text-secondary-700'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1 flex-wrap">
                  <h3 className="text-sm md:text-base font-bold text-foreground-900 whitespace-nowrap">{item.title}</h3>
                  <span className="text-xs text-foreground-500 bg-background-200/70 px-2 py-0.5 rounded whitespace-nowrap">{item.meta}</span>
                </div>
                <p className="text-xs md:text-sm text-foreground-600 truncate">{item.desc}</p>
              </div>

              <div className="flex items-center gap-2 flex-shrink-0">
                <span className="text-xs md:text-sm font-medium text-accent-600 whitespace-nowrap">{item.hot}</span>
                <span className={`text-sm ${
                  item.change === 'up' ? 'text-primary-500' : item.change === 'down' ? 'text-secondary-400' : 'text-foreground-400'
                }`}>
                  {item.change === 'up' && <i className="ri-arrow-up-line"></i>}
                  {item.change === 'down' && <i className="ri-arrow-down-line"></i>}
                  {item.change === 'same' && <i className="ri-subtract-line"></i>}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}